<template>
	<div>
		<header class="flex flex-align-center">
			<div class="header w-1700 flex flex-between flex-align-center">
				<div class="flex flex-align-center">
					<el-image :src="`${require('@/assets/img/header/logo.png')}`"
						style="width: 161.03px; height: 53.33px;cursor:pointer;" />
					<div class="menu flex flex-align-center">
						<p v-for="(item,index) in menu.list" :key="index" :class="index === menuIndex ? 'on': ''"
							@click="pathClick(item)">{{
                item.label
              }}</p>
					</div>
				</div>
				<div class="flex flex-align-center">
					<!-- <div class="search-box flex flex-align-center">
						<div class="icon">
							<el-image :src="`${require('@/assets/img/header/search-icon.png')}`"
								style="width: 18.82px; height: 16.95px" />
						</div>
						<el-input v-model="keyword" clearable placeholder="搜索课程关键字" />
					</div> -->
					<div v-if="dialog.isToken" class="avatar flex" style="align-items: center; color: #fff; font-weight: bold;">
						<img :src="dialog.avatar">
						<div style="margin-left: 10px;">{{dialog.userName}}</div>
					</div>
					<el-button v-else color="#4377F3" size="large" type="primary"
						@click="dialog.dialogVisible = true">登录
					</el-button>
				</div>
			</div>
		</header>
		<div class="height"></div>
		<el-dialog v-model="dialog.dialogVisible" :before-close="handleClose" append-to-body destroy-on-close title="登录"
			width="400px">
			<el-form ref="ruleForm" :model="dialog.ruleForm" :rules="dialog.rules" class="demo-ruleForm"
				label-width="100px">
				<el-form-item label="账号" prop="userName">
					<el-input v-model="dialog.ruleForm.userName" clearable placeholder="请输入账号"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="pass">
					<el-input v-model="dialog.ruleForm.pass" clearable placeholder="请输入密码" show-password></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">立即登录</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import VueCookies from "vue-cookies";

	export default {
		name: "headerIndex",
		props: ['menuIndex'],
		data() {
			return {
				dialog: {
					dialogVisible: false,
					ruleForm: {
						userName: '',
						pass: ''
					},
					rules: {
						userName: [{
							required: true,
							message: '账号不可为空',
							trigger: 'blur'
						}, ],
						pass: [{
							required: true,
							message: '密码不可为空',
							trigger: 'blur'
						}, ]
					},
					avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
					isToken: false,
					userName: ''
				},
				keyword: '',
				menu: {
					list: [{
						label: '公司介绍',
						path: '/about',
					}, {
						label: 'AI课程',
						path: '/course',
					}, {
						label: '企培专区',
						path: '/enterprise_training',
					}, {
						label: 'AI工具集',
						path: '/tool',
					}, {
						label: '开课时间表',
						path: '/timetable',
					// }, {
					// 	label: '数据大屏',
					// 	path: '/bi',
					},
					]
					
				}
			}
		},
		created() {
			if (VueCookies.get("token") && VueCookies.get("token") !== '') {
				this.dialog.isToken = true
			}
			if (VueCookies.get("avatar") && VueCookies.get("avatar") !== '') {
				this.dialog.avatar = VueCookies.get("avatar")
			}
			if (VueCookies.get("userName") && VueCookies.get("userName") !== '') {
				this.dialog.userName = VueCookies.get("userName")
			}
		},
		methods: {
			show() {
				this.dialog.dialogVisible = true
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.apiLogin(this.dialog.ruleForm).then(res => {
								this.$cookies.set("token", res.data.accessToken);
								this.$cookies.set("avatar", res.data.avatar ? res.data.avatar : 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg');
								this.$cookies.set("userName", res.data.userName ? res.data.userName : '');
								this.$message({
									message: '登录成功',
									type: 'success'
								});
								setTimeout(() => {
									location.reload()
								}, 1000);
							})
							.catch(err => {})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleClose(done) {
				done();
			},
			pathClick(item) {
				this.$router.push(item.path)
			}
		}
	}
</script>

<style lang="less" scoped>
	header {
		height: 80px;
		position: fixed;
		width: 100%;
		left: 0;
		top: 0;
		z-index: 1;

		&:after {
			content: '';
			backdrop-filter: blur(50px);
			background: rgba(0, 0, 0, 0.1);
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			right: 0;
			// z-index: 999999999;
		}

		.header {
			position: relative;
			z-index: 2;

			.avatar {
				cursor: pointer;

				img {
					width: 53.33px;
					height: 53.33px;
					border-radius: 100px;
				}
			}

			.search-box {
				background: #f3f3f3;
				width: calc(266.67px - 21.33px - 21.33px);
				height: 48px;
				padding: 0 21.33px;
				border-radius: 24px;
				margin: 0 48px 0 0;

				.icon {
					cursor: pointer;
				}

				::v-deep .el-input {
					margin: 0 0 0 18px;

					.el-input__wrapper {
						background: transparent;
						border: none;
						box-shadow: none;
						font-size: 18.67px;
					}
				}
			}

			.menu {
				margin: 0 0 0 180.3px;

				p {
					color: #ffffff;
					font-size: 18.67px;
					font-family: 'HarmonyOS Sans SC', serif;
					margin: 0 0 0 54px;
					cursor: pointer;
					transition: color 0.3s;

					&.on {
						color: #4377f3;
					}

					&:hover {
						color: #4377f3;
					}

					&:first-child {
						margin: 0;
					}
				}
			}
		}
	}

	.height {
		//height: 80px;
	}
</style>